import { useMemo } from "react";
import { movies } from "@/mocks/movies";
import { newsList } from "@/mocks/news";
import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import HomeSidebar from "@/pages/home/components/HomeSidebar";
import QuickEntries from "@/pages/home/components/QuickEntries";
import HotMovies from "@/pages/home/components/HotMovies";
import NewsSection from "@/pages/home/components/NewsSection";

export default function Home() {
  usePageMeta({
    title: "秋霞影院 - 高清电影电视剧在线观看与影视资讯平台",
    description:
      "秋霞影院为您提供丰富的电影和电视剧资源，涵盖各类影视作品及最新资讯，方便用户在线浏览和了解影视相关内容。",
    keywords: "秋霞影院,电影,电视剧,影视资源,影视资讯,在线观看,影视平台",
  });

  const featured = useMemo(
    () => [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, 5),
    []
  );
  const ranking = useMemo(
    () => [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, 6),
    []
  );

  return (
    <div className="mx-auto w-full max-w-[1400px] px-4 py-6 md:px-6 md:py-8">
      <h1 className="sr-only">秋霞影院 - 高清电影电视剧在线观看与影视资讯平台</h1>
      <div className="grid gap-4 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <HeroCarousel slides={featured} />
        </div>
        <div className="lg:col-span-1">
          <HomeSidebar ranking={ranking} />
        </div>
      </div>

      <QuickEntries />
      <HotMovies movies={movies} />
      <NewsSection news={newsList} />
    </div>
  );
}